import '../styles/splash.css'
import { useEffect } from "react";

export default function Splash() {
  useEffect(() => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }, []);
  return (
    <div className="splash__container">
      <div className='splash'>
        <span className='first__name'>V</span>
        <span className='first__name'>A</span>
        <span className='first__name'>I</span>
        <span className='first__name'>B</span>
        <span className='first__name'>H</span>
        <span className='first__name'>A</span>
        <span className='first__name'>V</span>
      </div>
      <div className='splash'>
        <span className='last__name'>A</span>
        <span className='last__name'>S</span>
        <span className='last__name'>W</span>
        <span className='last__name'>A</span>
        <span className='last__name'>L</span>
      </div>
      <div className="progress-bar">
        <span className="bar">
          <span className="progress"></span>
        </span>
      </div>
    </div>
  )
}
